export const CurrenciesShortHand: Partial<Record<string, string>> = {
  RUB: '₽',
  USD: '$',
  KZT: '₸',
  EUR: '€',
  MXN: '¢',
  UAH: '₴',
};
